import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import EvaluationsRoutes from "./evaluations/index";
import ActivityRoutes from "./activity/index";
import LessonRoutes from "./lesson/index";
import TaskRoutes from "./task/index";
import Progress from "@/views/progress/progress";
import PageNotFound from "@/views/errors/404.vue";
import AccessDenied from "@/views/errors/no-login.vue";
import DisconectView from "@/views/errors/DisconectView.vue";
import HomePage from "@/views/HomePage.vue";

import Store from "../store/index";

// Functions

function auth(to: any, from: any, next: any) {
    Store.dispatch("actionGetUser")
        .then(response => {
            if (response) {
                next({ name: "Disconect" });
            } else {
                next();
            }
        })
        .catch(error => {
            next({ name: "Disconect" });
            console.log(error);
        });
}

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    ...ActivityRoutes,
    ...LessonRoutes,
    // ...EvaluationsRoutes,
    ...TaskRoutes,
    {
        path: "/",
        component: HomePage,
        beforeEnter: auth
        // children:[
        //     {
        //         path:'new-lesson',
        //         name: 'NewLesson',
        //         component: FormLesson
        //     }
        // ]
    },
    
    {
        path: "/progress",
        name: "Progreso",
        component: Progress,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "*",
        component: PageNotFound,
        meta: {
            requiresAuth: true
        }
    },
    { path: "/access-denied", component: AccessDenied },
    {
        path: "/desconectado",
        name: "Disconect",
        component: DisconectView
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

// Guard Route
router.beforeEach((to, from, next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
        console.log("### SECURITY MIDDLEWARE ###");

        if (Store.getters.getIsLogged) {
            next();
        } else {
            next({ name: "Disconect" });
        }
    } else {
        next();
    }
});

export default router;
